import { render, staticRenderFns } from "./ProductionTrends.vue?vue&type=template&id=0a883c15&scoped=true"
import script from "./ProductionTrends.vue?vue&type=script&lang=js"
export * from "./ProductionTrends.vue?vue&type=script&lang=js"
import style0 from "./HuddleComponentsModern.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./ProductionTrends.vue?vue&type=style&index=1&id=0a883c15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a883c15",
  null
  
)

export default component.exports